const moveVideo = () => {
  const pageIdentifier = document.querySelector('#page-type-identifier');
  if (pageIdentifier) {
    let videoObject = '';
    if (pageIdentifier.getAttribute('data-item-type') === 'wistiar') {
      videoObject = document.querySelector(
        'body.wistiar .entry-wrapper .entry .single-embed-wrapper'
      );
    } else if (pageIdentifier.getAttribute('data-item-type') === 'youtube') {
      videoObject = document.querySelector('body.youtube .entry-wrapper .single-embed-wrapper');
    }

    const entryObject = document.querySelector('body .entry-wrapper .entry');
    if (videoObject && entryObject) {
      entryObject.appendChild(videoObject);
    }
  }
};

module.exports = { moveVideo };



// WEBPACK FOOTER //
// ./script-partials/moveVideo.js